export default __webpack_public_path__ + "static/media/logo.47a6f264.png";